// extracted by mini-css-extract-plugin
export var active = "TabularGrid-module--active--b2e15";
export var label = "TabularGrid-module--label--b2ae6";
export var tabMenu = "TabularGrid-module--tabMenu--44e6f";
export var tabMenuItem = "TabularGrid-module--tabMenuItem--ffb9c";
export var tabSection = "TabularGrid-module--tabSection--6da60";
export var tabSectionItem = "TabularGrid-module--tabSectionItem--c1977";
export var tabSectionItemImg = "TabularGrid-module--tabSectionItemImg--8ae41";
export var tabularGrid = "TabularGrid-module--tabularGrid--8f3ba";
export var withoutBg = "TabularGrid-module--withoutBg--c8c57";